export default __webpack_public_path__ + "static/media/Master-Plan-Fanal-Sun-Capital.73d98eb4.jpg";